export default __webpack_public_path__ + "static/media/home.7cc6ec72.svg";